import axiosWrapper from './axiosWrapper';
import { getCorkboards } from '../cache/dataClient';
import cacheSync from '../cache/cacheSync';

const corkboardService = {
  // Get all corkboards for a project (offline-first)
  async getCorkboards(projectId, options = {}) {
    const { useCache = true } = options;
    const result = await getCorkboards(projectId, { useCache });

    if (result.error && !result.fromCache) {
      return { data: null, error: result.error };
    }

    // Return in format expected by existing code
    return {
      data: { corkboards: result.data || [] },
      error: null,
      fromCache: result.fromCache,
    };
  },

  // Get a single corkboard by ID
  async getCorkboardById(projectId, corkboardId) {
    const response = await axiosWrapper({
      method: 'get',
      path: `projects/${projectId}/corkboards/${corkboardId}`,
    });
    return response;
  },

  // Create a new corkboard
  async createCorkboard(projectId, corkboardData) {
    const response = await axiosWrapper({
      method: 'post',
      path: `projects/${projectId}/corkboards`,
      data: corkboardData,
    });
    // Update cache after successful creation
    if (!response.error) {
      cacheSync.syncAfterMutation('corkboards', response, 'create').catch((err) => {
        console.warn('[corkboardService] Error updating cache after create:', err);
      });
    }
    return response;
  },

  // Update an existing corkboard
  async updateCorkboard(projectId, corkboardId, corkboardData) {
    const response = await axiosWrapper({
      method: 'put',
      path: `projects/${projectId}/corkboards/${corkboardId}`,
      data: corkboardData,
    });
    // Update cache after successful update
    if (!response.error) {
      cacheSync.syncAfterMutation('corkboards', response, 'update').catch((err) => {
        console.warn('[corkboardService] Error updating cache after update:', err);
      });
    }
    return response;
  },

  // Delete a corkboard
  async deleteCorkboard(projectId, corkboardId) {
    const response = await axiosWrapper({
      method: 'delete',
      path: `projects/${projectId}/corkboards/${corkboardId}`,
    });
    // Update cache after successful delete
    if (!response.error) {
      cacheSync.syncAfterMutation('corkboards', { id: corkboardId }, 'delete').catch((err) => {
        console.warn('[corkboardService] Error updating cache after delete:', err);
      });
    }
    return response;
  },
};

export default corkboardService;
